<template>
    <md-layout style="padding: 20px;">
        <div class="col-md-12" style="    width: 100%;">
            <md-input-container md-clearable>
                <label>Codigo de Bono</label>
                <md-input v-model="bonusCode"></md-input>
            </md-input-container>
            <md-button class="md-raised md-primary" @click="search()">Verificar</md-button>
            <div v-if="search_error.status == 'ERROR'" class="alert alert-danger">{{search_error.msg}}</div>
        </div>
        <div style="background: #f0eded;width: 100%;" v-if="show_search">
            <div class="col-md-12" style="text-align:center">
                <h2>Bono {{bonus.code}}</h2>
                <h4 style="font-weight: 400;" v-if="bonus.used == 0 && bonus.doctor">Bono para Prestador: <b>{{doctorFullName}}</b> (RUT: {{bonus.doctor.code}})</h4>
            </div>
            <div class="col-md-6">
                <h3>Estado de uso del Bono:
                    <span v-if="bonus.used == 1" class="badge badge-danger">Utilizado</span>
                    <span v-if="bonus.used == 0" class="badge badge-success">Disponible</span>
                </h3>
                <h3>Estado de pago del Bono:
                    <span v-if="bonus.paid == 1" class="badge badge-success">Pagado</span>
                    <span v-if="bonus.paid == 0" class="badge badge-danger">No Pagado</span>
                </h3>
                <table class="bonus_info">
                    <tr>
                        <td><b>Valor Prestacion</b></td>
                        <td>{{ bonus.bonus_task.country.currency.prefix }} {{ formatNumber(bonus.price, bonus.bonus_task.country.currency.code) }} {{ bonus.bonus_task.country.currency.sufix }} {{ bonus.bonus_task.country.currency.description }}</td>
                    </tr>
                    <tr>
                        <td><b>Descuento AMOL</b></td>
                        <td>- {{ bonus.bonus_task.country.currency.prefix }} {{ formatNumber(bonus.discount, bonus.bonus_task.country.currency.code) }} {{ bonus.bonus_task.country.currency.sufix }} {{ bonus.bonus_task.country.currency.description }}</td>
                    </tr>
                    <tr>
                        <td><b>Valor a Pagar por Paciente</b></td>
                        <td>{{ bonus.bonus_task.country.currency.prefix }} {{ formatNumber(bonus.final_price, bonus.bonus_task.country.currency.code) }} {{ bonus.bonus_task.country.currency.sufix }} {{ bonus.bonus_task.country.currency.description }}</td>
                    </tr>
                </table>
                <div v-if="bonus.used == 1" class="alert alert-info float-spans" style="margin-top: 10px">
                    <h3 style="margin:0">Fecha de Atencion:
                    <span style="font-weight: 400;">
                        {{ bonus_date_at }}
                    </span>
                    </h3>
                    <h4 style="margin:0">Prestador:
                    <span style="font-weight: 400;">
                        {{ doctorFullName }} (RUT: {{bonus.doctor.code}})
                    </span>
                    </h4>
                </div>
            </div>
            <div class="col-md-6">
                <h3>Fecha de Emision:</h3>
                <span>
                    {{ bonus_date }}
                </span>

                <h3>Prestacion:</h3>
                <span>{{bonus.bonus_task.name}}</span>
                <h3>Codigo Prestacion:</h3>
                <span>{{bonus.bonus_task.code}}</span>
            </div>
            <div class="col-md-12">
            </div>
            <div class="col-md-6 float-spans" style="text-align:left">
                <hr>
                <h3>Beneficiario:</h3>

                <b>Nombre:</b> <span class="name">{{ patientFullName }}</span><br>
                <b>RUT: </b><span>{{bonus.patient.code}}</span><br>
                <b>Edad: </b><span>{{ patientAge }}</span><br>
                <b>Fecha de Nacimiento: </b><span>{{bonus.patient.birth_date}}</span><br>
            </div>
            <div class="col-md-6 float-spans" style="text-align:left">
                <hr>
                <h3>Titular:</h3>
                <b>Nombre:</b> <span class="name">{{ creatorFullName }}</span><br>
                <b>RUT: </b><span>{{bonus.creator.rut}}</span><br>
            </div>
            <div class="col-md-12">
                <hr>
                <div class="alert alert-info" v-if="not_allowed">
                    El bono solo se puede utilizar con el Prestador <b>{{doctorFullName}}</b> (RUT:{{bonus.doctor.code}}).
                </div>
                <div class="alert alert-info" v-if="bonus.paid == 0 && bonus.used == 0 && !not_allowed">
                Al presionar el boton "Utilizar Bono" usted como Prestador declara haber recibido el pago de <b> {{ bonus.bonus_task.country.currency.prefix }} {{ formatNumber(bonus.final_price, bonus.bonus_task.country.currency.code) }} {{ bonus.bonus_task.country.currency.sufix }} {{ bonus.bonus_task.country.currency.description }}</b> por parte del Paciente.
                </div>
                <div class="alert alert-info" v-if="bonus.paid == 1 && bonus.used == 0 && !not_allowed">
                Al presionar el boton "Utilizar Bono" usted como Prestador recibira de manera automatica a su cuenta bancaria el valor del bono.
                </div>
                <br>
                <br>
                <md-button v-if="bonus.used == 0 && !not_allowed" class="md-raised md-warn" @click="use_bonus()">Utilizar Bono</md-button>
                <md-button class="md-raised" @click="launch_print()">Imprimir</md-button>
            </div>
        </div>
    </md-layout>
</template>
<script>
    import { doctor } from '../../config/api.js';
    const swal = require('sweetalert2');
    import moment from 'moment';

    export default {
        data() {
            return {
                bonusCode: '',
                show_search: false,
                not_allowed: false,
                search_error: {
                    msg: '',
                    status: 'NONE'
                },
                bonus: {
                    used: 0,
                    paid:0,
                    bonus_task: {
                        country: {
                            currency: {

                            }
                        },
                        name: ''
                    },
                    patient: {
                        code: '',
                        name: ''
                    },
                    creator: {
                        code: '',
                        name: ''
                    },
                    doctor: {
                        code: '',
                        name: ''
                    }
                }
            }
        },
        created() {
            console.log("params",  this.$route.params)
            if( this.$route.params.bonusCode) {
                this.bonusCode = this.$route.params.bonusCode;
                this.search();
            }
        },
        computed: {
            // Get Language
            creatorFullName (){
                return this.bonus.creator.name ? (this.bonus.creator.name+" "+(this.bonus.creator.lastname ? this.bonus.creator.lastname : '')+" "+(this.bonus.creator.lastname2 ? this.bonus.creator.lastname2 : '')) : "";
            },
            doctorFullName (){
                return this.bonus.doctor.name ? (this.bonus.doctor.name+" "+(this.bonus.doctor.lastname ? this.bonus.doctor.lastname : '')+" "+(this.bonus.doctor.lastname2 ? this.bonus.doctor.lastname2 : '')) : "";
            },
            bonus_date(){
                return moment(this.bonus.created_at).format('DD/MM/YYYY');
            },
            bonus_date_at(){
                return moment(this.bonus.updated_at).format('DD/MM/YYYY');
            },
            patientAge(){
                return moment().diff(moment(this.bonus.patient.birth_date, 'DD/MM/YYYY'), 'years');
            },
            patientFullName(){
                return this.bonus.patient.name ? (this.bonus.patient.name+" "+(this.bonus.patient.lastname ? this.bonus.patient.lastname : '')+" "+( this.bonus.patient.lastname2 ? this.bonus.patient.lastname2 : '')) : "";
            },
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            launch_print(){
                window.print();
            },
            formatNumber(value, coin) {
                if(coin == "CLP"){
                    return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : 0
                }
                return value
            },
            // Search
            search() {
                this.bonus = {
                    used: 0,
                    paid:0,
                    bonus_task: {
                        country: {
                            currency: {

                            }
                        },
                        name: ''
                    },
                    patient: {
                        code: '',
                        name: ''
                    },
                    creator: {
                        code: '',
                        name: ''
                    },
                    doctor: {
                        code: '',
                        name: ''
                    }
                }
                this.show_search = false;
                if(!this.bonusCode || this.bonusCode.length < 8){
                    return;
                }
                this.not_allowed = false;
                this.search_error = {
                    msg: '',
                    status: 'NONE'
                };
                let url = doctor.api.bonus+this.bonusCode+"?use_code=true";
                this.$http.get(url, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    }).then(response => {
                        this.bonus = response.data.data;
                        this.show_search = true;
                    }).catch(error => {
                        this.search_error = error.response.data;
                    });
            },
            use_bonus(){
                let data = {bonus_id: this.bonus.id};
                let parent = this.$auth.getParent();
                let url = doctor.api.use_bonus;
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                self = this;
                this.$http.post(url , data, {
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                    }).then(response => {
                        this.bonus = response.data.data;
                        this.not_allowed = (this.bonus.used == 0)
                    }).catch(error => {
                         console.log(error)
                    });
            },
            // Get path
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    @import '../../../assets/styles/responsive.styl'
    @import '../../assets/styles/boots.styl'
</style>
<style scoped>
.bonus_info {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
}
.bonus_info td {
    border: 1px solid black;
}
.alert.alert-danger {
    background: #dc3545!important;
    color: white;
}
.alert.alert-success {
    background: #28a745!important;
    color: white;
}
.alert.alert-info {
    background: #d1ecf1;
}
.alert {
    width: 100%;
    min-height: 60px;
    line-height: 40px;
    padding: 10px;
}
.badge {
    float: right;
}
.badge-success {
    color: #fff;
    background-color: #28a745;
}
.badge-danger {
    color: #fff;
    background-color: #dc3545;
}
.float-spans span {
    float: right;
}
.name {
    text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Validate.vue?21c8d70d